<template>
  <div>
    <div class="col-12 p-0 listItem">
      <CasinoResult
        v-for="result of results"
        v-bind:key="result.id"
        v-bind:compareMode="false"
        v-bind:casino="result"
      />
    </div>
  </div>
</template>

<script>
import CasinoResult from './CasinoResult';
export default {
  name: 'CasinoResults',
  props: ['results'],

  components: {
    CasinoResult,
  },
};
</script>
